module.exports = __webpack_public_path__ + "static/media/backc++.21503f2d.jpg";